import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-common-dbhandler',
  templateUrl: './common-dbhandler.component.html',
  styleUrls: ['./common-dbhandler.component.css']
})
export class CommonDbhandlerComponent implements OnInit {
  // get the start page route as an input
  @Input()startPage = "";
   // get the app name to set as an input to subject
  @Input()appName = "";

  constructor() { }

  ngOnInit(): void {
  }

  mouseoutmsg():boolean{
    window.status='';
    return true
  }

  mouseovermsg():boolean{
    window.status='Send email to Customer Service';
    return true
  }
}
